<template>
  <div id="app">
    <router-view />
    <Loading />
  </div>
</template>

<script>
import Loading from '@/components/Loading'
export default {
  name: 'App',
  components: {
    Loading
  },
  created () {
    this.$store.dispatch('getUserInfo')
  }
}
</script>

<style lang="scss">
@import './style/common';
#app {
  min-width: 960px;
  min-height: 540px;
  height: 100%;
  font-size: 16px;
}
</style>
